/* SEASONS: product card videos in Bestsellers.
   Desktop: play a short muted video when hovering the card.
   Phones (no hover): products in AUTO alternate photo and video while the card is on screen.
   Add products here: "product-handle": "video URL (Shopify Files, 480p mp4)". */
(function () {
  var VIDEOS = {
    "three-fish-chess-roll": "https://cdn.shopify.com/videos/c/vp/6bf2cc3512734f619969cba26358d403/6bf2cc3512734f619969cba26358d403.SD-480p-0.9Mbps-96048594.mp4",
    "cold-smoked-salmon-yukola": "https://cdn.shopify.com/videos/c/vp/1acd79b8d29b4a8695219980a26cc6ef/1acd79b8d29b4a8695219980a26cc6ef.SD-480p-0.9Mbps-96049855.mp4",
    "cold-smoked-black-pepper-salmon-yukola": "https://cdn.shopify.com/videos/c/vp/01ae668970a9437cb125ec69a3abac7d/01ae668970a9437cb125ec69a3abac7d.SD-480p-0.9Mbps-95830766.mp4"
  };
  var AUTO = ["three-fish-chess-roll", "cold-smoked-black-pepper-salmon-yukola"];
  var SCOPE = '[id$="__bestsellers"] .card-wrapper';
  var hover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
  var css = '.ss-hover-video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity .35s ease;z-index:2;pointer-events:none}' +
    '.ss-video-on .ss-hover-video{opacity:1}' +
    '.ss-has-video .media.media--hover-effect>img+img{display:none!important}' +
    '.ss-has-video:hover .media.media--hover-effect>img:first-child{opacity:1!important}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
  function makeVideo(src, m) {
    var v = document.createElement('video');
    v.muted = true; v.loop = true; v.playsInline = true; v.preload = 'auto';
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
    v.className = 'ss-hover-video'; v.src = src; m.appendChild(v);
    return v;
  }
  /* Phones: photo 1.5 s -> video (max 6 s) -> photo 2 s -> video ... while the card is on screen */
  var PHOTO_FIRST = 1500, PHOTO_BETWEEN = 2000, VIDEO_MAX = 6000;
  function cycle(w) {
    clearTimeout(w.__ssT);
    if (!w.__ssIn) return;
    var v = w.__ssV;
    if (!v) {
      v = w.__ssV = makeVideo(w.__ssSrc, w.__ssM);
      v.loop = false;
      v.addEventListener('ended', function () { stop(w, true); });
    }
    try { v.currentTime = 0; } catch (e) {}
    var p = v.play();
    var go = function () { if (!w.__ssIn) { v.pause(); return; } w.classList.add('ss-video-on'); w.__ssT = setTimeout(function () { stop(w, true); }, VIDEO_MAX); };
    if (p && p.then) p.then(go).catch(function () {}); else go();
  }
  function stop(w, again) {
    clearTimeout(w.__ssT);
    w.classList.remove('ss-video-on');
    var v = w.__ssV;
    if (v) setTimeout(function () { if (!w.classList.contains('ss-video-on')) v.pause(); }, 400);
    if (again && w.__ssIn) w.__ssT = setTimeout(function () { cycle(w); }, PHOTO_BETWEEN);
  }
  var io = (!hover && 'IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var w = e.target;
      if (e.isIntersecting) {
        if (w.__ssIn) return;
        w.__ssIn = true; clearTimeout(w.__ssT);
        w.__ssT = setTimeout(function () { cycle(w); }, PHOTO_FIRST + (w.__ssN || 0) * 3000);
      } else {
        w.__ssIn = false; stop(w, false);
      }
    });
  }, { threshold: 0.5 }) : null;
  function init() {
    document.querySelectorAll(SCOPE).forEach(function (w) {
      if (w.__ssVid) return;
      var a = w.querySelector('a[href*="/products/"]'); if (!a) return;
      var h = a.getAttribute('href').split('/products/')[1].split(/[?#]/)[0];
      var src = VIDEOS[h]; if (!src) return;
      var m = w.querySelector('.card__media .media') || w.querySelector('.card__media'); if (!m) return;
      if (!hover) {
        if (!io || AUTO.indexOf(h) < 0) return;
        w.__ssVid = 1; w.classList.add('ss-has-video'); w.__ssSrc = src; w.__ssM = m; w.__ssN = AUTO.indexOf(h); io.observe(w);
        return;
      }
      w.__ssVid = 1; w.classList.add('ss-has-video');
      var v;
      w.addEventListener('mouseenter', function () {
        if (!v) v = makeVideo(src, m);
        try { v.currentTime = 0; } catch (e) {}
        var p = v.play(); if (p && p.catch) p.catch(function () {});
        w.classList.add('ss-video-on');
      });
      w.addEventListener('mouseleave', function () { w.classList.remove('ss-video-on'); if (v) v.pause(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
